// export default Actions;

//action asynchrone
//ex
export const updateValue = ({ commit }: any, payload: Number) => {
  commit("updateValue", payload);
};
